import React from "react";
import { graphql } from "react-apollo";
import { flowRight as compose } from "lodash";
import gql from "graphql-tag";
import {connect} from "react-redux";
import Loading from "../../components/Loading";
import Button from "../../components/Button";
import {cancelSetBillingAddress} from "../../actions/AccountApiActions";
import {createValidationErrors, createErrors} from "../../lib/ErrorFormatter";

class SetBillingAddressFormContainer extends React.Component {

  constructor(props) {
    super(props);
    this.state = { 
      errors: [],
      status: "busy"
    }
  }

  componentDidMount() {
    this.handleSubmit();
  }

  handleSubmit() {
    let values = {
      accountId: this.props.accountId,
      name: this.props.address.name,
      addressAddressLine1: this.props.address.addressAddressLine1,
      addressAddressLine2: this.props.address.addressAddressLine2,
      addressCity: this.props.address.addressCity,
      addressPostcode: this.props.address.addressPostcode,
      addressStateProvince: this.props.address.addressStateProvince,
      addressCountryCode: this.props.address.addressCountryCode
    }

    return this.props.changeBillingAddress(values)
      .then((response) => {
        if (response.data.changeBillingAddress.errors.length <= 0) {
          this.props.cancelSetBillingAddress();
        } else {
          let errors = createValidationErrors(response.data.changeBillingAddress.errors);
          this.setState({errors: errors, status: "error"});
        }
      })
      .catch((err) => {
        this.setState({errors: createErrors(err), status: "error"});
      });      
  }

  handleCancel() {
    this.props.cancelSetBillingAddress();
  }

  render() {
    return (
      <div className="SetBillingAddressFormContainer status">        
        {this.renderView(this.state.status)}
      </div>
    )    
  }

  renderView(status) {
    switch(status) {
      case "error":
        return <React.Fragment>
                 <h4>An error occured</h4>
                 <p>An unknown error occured when changing the billing address. Please try again.</p>
                 <Button label="Cancel" primary={true} onClick={this.handleCancel.bind(this)} />
               </React.Fragment>                
      default: 
        return <React.Fragment>
                <Loading />
                 <h4>Standby</h4>
                 <p>Updating billing address</p>
               </React.Fragment>
    }
  }


}

const CHANGE_BILLING_ADDRESS = gql`
  mutation changeBillingAddress($data: BillingAddressInput!) {
    changeBillingAddress(input: $data) {
      errors { key message }
    }
  }
`;


const withQueries = compose(
  graphql(CHANGE_BILLING_ADDRESS, {
    props: ({ mutate }) => ({
      changeBillingAddress: (data) => mutate({
        variables: { data: data }
      })
    })
  })  
);

export default connect(null, {cancelSetBillingAddress})(withQueries(SetBillingAddressFormContainer));

